
















































import { Component, Vue, Prop, InjectReactive } from 'vue-property-decorator';
import { GQL_paycheckDataForPaycheckListForm_currentUnit, GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations } from '@/queries/__generated__/paycheckDataForPaycheckListForm';
import Altinn from '@/app/Altinn';
import flatMap from 'lodash/flatMap';
import PaycheckDraft from '@/app/PaycheckDraft';
import { GQL_currentUnitPaycheckPeriods_currentUnit_paycheckPeriods } from '@/queries/__generated__/currentUnitPaycheckPeriods';
import { isEmployedDuringPeriod } from '@/app/WorkRelation';
import dayjs from 'dayjs';

@Component
export default class PaycheckDraftPeriodFormIrrelevantWorkRelations extends Vue {
  @Prop({ type: Object, required: true }) private currentUnit!: GQL_paycheckDataForPaycheckListForm_currentUnit;
  @InjectReactive() private paycheckPeriod!: GQL_currentUnitPaycheckPeriods_currentUnit_paycheckPeriods;

  private expanded = false;

  private unemployedWorkRelationId = '';
  private pensionWorkRelationId = '';

  private get allWorkRelations(): GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations[] {
    return flatMap(this.currentUnit.subUnits, subUnit => subUnit.workRelations);
  }

  private get pensionWorkRelations(): GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations[] {
    return this.allWorkRelations.filter(workRelation =>
      workRelation.employmentType === Altinn.pensionEmploymentType &&
      !workRelation.paycheckDrafts.length &&
      !workRelation.paychecks.length &&
      (!workRelation.pensionEndDate || dayjs.strict(workRelation.pensionEndDate).isSameOrAfter(this.paycheckPeriod.startDate) ),
    );
  }

  private get unemployedWorkRelations(): GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations[] {
    return this.allWorkRelations.filter(workRelation =>
      workRelation.employmentType !== Altinn.pensionEmploymentType &&
      !workRelation.paycheckDrafts.length &&
      !workRelation.paychecks.length &&
      !isEmployedDuringPeriod(workRelation, this.paycheckPeriod),
    );
  }

  private addPaycheckDraftToWorkRelation(workRelationId: string): void {
    const workRelation = this.allWorkRelations.find(workRelation => workRelation.id === workRelationId);

    if (workRelation) {
      workRelation.paycheckDrafts.push(
        PaycheckDraft.newDraft(workRelationId, this.paycheckPeriod.id, true),
      );
    }
  }
}
